module.exports = __webpack_public_path__ + "c_static/img/淘气值上传页面.b6749db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/完善资料/淘气值上传页面.jpg
// module id = bMY4
// module chunks = 33